// ========================================
// HOOK useSiteSettings
// Gestion des paramètres du site
// ========================================

import { useState, useEffect, useCallback } from 'react';
import { getSiteSettings, updateSiteSettings } from '../services/firebase/siteService';
import { toast } from 'react-toastify';

const useSiteSettings = (autoFetch = true) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const fetchSettings = useCallback(async () => {
    setLoading(true);
    setError(null);

    const result = await getSiteSettings();

    if (result.success) {
      setSettings(result.data);
    } else {
      setError(result.error);
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    if (autoFetch) {
      fetchSettings();
    }
  }, [autoFetch, fetchSettings]);

  const saveSettings = async (newSettings) => {
    setSaving(true);
    const result = await updateSiteSettings(newSettings);

    if (result.success) {
      setSettings(prev => ({ ...prev, ...newSettings }));
      toast.success('Paramètres sauvegardés !');
    } else {
      toast.error('Erreur lors de la sauvegarde');
    }

    setSaving(false);
    return result;
  };

  return {
    settings,
    loading,
    saving,
    error,
    fetchSettings,
    saveSettings
  };
};

export default useSiteSettings;